<template>
  <div class="p-list-box">
    <div class="p-manage-tool">
      <div
        class="p-list-search"
      >
        <a-input
          v-model="searchVal"
          style="width: 208px;"
          :placeholder="truenameTit"
          @keyup="searchMethod"
        />
        <i
          class="icon iconfont iconicon-test45"
          @click="searchMethod"
        />
      </div>
    </div>
    <div class="p-list">
      <template v-if="datasReady">
        <ul
          v-if="datas.length"
          class="scroll_bar_beautify_ff origin-list-ul"
        >
          <li
            v-for="(item,index) in datas"
            :key="index"
            :class="{active: item.userid === selectId }"
            @click="clickHandle(item)"
          >
            <div class="p-item-tit">
              <h2>
                {{ item.truename }}
                <span v-if="item.isfounder===1">[{{ $t('message["130"]') }}]</span>
              </h2>
            </div>
            <!-- <p>{{ item.mobile }}</p> -->
          </li>
        </ul>
        <div
          v-else
          class="no-search-result"
        >
          {{ $t('message["1553"]') }}
        </div>
      </template>
      <!-- <div v-else>
        <a-spin tip="loading" />
      </div> -->
    </div>
  </div>
</template>
<script>
// import EditAdminList from './EditAdminList'
import { mapState, mapActions, mapGetters } from 'vuex'
export default {
  components: {
  },
  data () {
    return {
      searchVal: ''
    }
  },
  computed: {
    ...mapState('organization/person', ['datas', 'cId', 'isAdmin', 'datasReady']),
    ...mapGetters('organization/person', ['selectId', 'treeList']),
    truenameTit () {
      return this.$t('message["665"]')
    }
  },
  mounted () {
    this.searchMethod = this.$debounce(this.searchMethod, 1000)
  },
  methods: {
    ...mapActions('organization/person', ['fetchItemInfoDatas', 'fetchCurrentDatas']),
    async clickHandle (item) {
      const chain = await this.fetchItemInfoDatas({ cid: this.cId, userid: item.userid })
      chain.fetch()
    },
    async searchMethod () {
      const chain = await this.fetchCurrentDatas({ cid: this.cId })
      chain
        .params({ cid: this.cId, keywords: this.searchVal })
        .fetch()
    }
  }
}
</script>

<style lang="scss" scoped>
.p-list-box::v-deep {
  width: 238px;
  float: left;
  min-height: 500px;
  .no-search-result{
    padding: 16px 0;
    text-align: center;
  }

  .p-manage-tool {
    padding: 16px;
    text-align: center;

    .p-list-search {
      position: relative;
      width: 208px;

      .icon {
        font-size: 14px;
        color: #ccc;
        position: absolute;
        right: 10px;
        top: 7px;
      }
    }
  }

  .p-list-search .el-input__inner {
    width: 152px;
    top: 9px;
  }

  .p-list {
    border-top: 1px solid #ebebeb;
    padding: 8px 0 24px;

    .origin-list-ul {
      max-height: 500px;
      overflow-y: auto;
       li {
      padding: 8px 16px;
      list-style: none;

      .p-item-tit {
        position: relative;

        h2 {
          display: inline-block;
          line-height: 24px;
          font-size: 14px;
        }

        .p-role {
          height: 20px;
          line-height: 20px;
          padding: 0 6px;
          color: #fff;
          position: absolute;
          right: 0;
          background: #a57ec8;
          font-size: 12px;
          border-radius: 4px;
        }
      }

      p {
        font-size: 12px;
        color: #b3b3b3;
        line-height: 16px;
        padding-top: 6px;
      }
    }

    li:hover,
    li.active {
      background: #f5f5f5;

      h2 {
        font-weight: bold;
        color: #5077aa;
      }
    }
    }
  }
}
</style>
